<script lang="ts">
	import { validateUrl } from '../form/validations/validations'

	interface Props {
		url: string
	}

	let { url }: Props = $props()

	function getDomainFromUrl(url: string) {
		try {
			return new URL(url).hostname
		} catch (e) {
			return ''
		}
	}

	let domain = $derived(getDomainFromUrl(url))
</script>

{#if validateUrl(url) && domain}
	<div style="background: url(https://logo.clearbit.com/{domain}?size=28)" class="h-7 w-7"></div>
{/if}
